// src/pages/admin/ProgramSettings.jsx
import React, { useEffect, useState } from "react";
import { getSettings, saveSettings, defaultSettings } from "../../lib/db";
import { Btn, Field, Input, Toast, Spinner, SectionLabel, DetailCard } from "../../components/UI";

export default function ProgramSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading]   = useState(true);
  const [toast, setToast]       = useState("");

  useEffect(() => {
    getSettings().then(s => { setSettings(s); setLoading(false); });
  }, []);

  const handleSave = async () => {
    await saveSettings(settings);
    setToast("Settings saved!"); setTimeout(() => setToast(""), 3000);
  };

  const setTier = (i, key, val) =>
    setSettings(s => { const t=[...s.tiers]; t[i]={...t[i],[key]:val}; return {...s,tiers:t}; });

  if (loading) return <Spinner />;

  return (
    <div>
      <Toast msg={toast} onClose={() => setToast("")} />
      <div style={{ padding:"36px 48px 0" }}>
        <h1 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:300 }}>Program Settings</h1>
        <p style={{ fontSize:13, color:"var(--mid)", marginTop:4 }}>Configure tiers, rates, and payout rules</p>
      </div>
      <div style={{ padding:"24px 48px 48px" }}>

        <SectionLabel>Commission Tiers</SectionLabel>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:16, marginBottom:24 }}>
          {settings.tiers.map((tier, i) => (
            <div key={i} style={{ background:"var(--warm-white)", border:`1px solid ${i===1?"var(--gold)":"var(--border)"}`, borderRadius:4, padding:22 }}>
              <div style={{ fontSize:9, fontWeight:500, letterSpacing:"0.18em", textTransform:"uppercase", color:"var(--gold)", marginBottom:8 }}>Tier {i+1}</div>
              <Field label="Tier Name"><Input value={tier.name} onChange={e=>setTier(i,"name",e.target.value)} /></Field>
              <Field label="Commission Rate (%)"><Input type="number" value={tier.rate} onChange={e=>setTier(i,"rate",Number(e.target.value))} /></Field>
              <Field label="Min Annual Sales ($)"><Input type="number" value={tier.minSales} onChange={e=>setTier(i,"minSales",Number(e.target.value))} /></Field>
              <Field label="Max Annual Sales ($)"><Input type="number" value={tier.maxSales||""} onChange={e=>setTier(i,"maxSales",e.target.value?Number(e.target.value):null)} placeholder="No limit" /></Field>
              <Field label="Bonus when member reaches this tier" hint="Shown on Program Details; leave blank for no bonus line (typical for the entry tier).">
                <Input value={tier.tierReachBonus ?? ""} onChange={e=>setTier(i,"tierReachBonus",e.target.value)} placeholder="e.g. Milestone prize — showroom coordinates" />
              </Field>
            </div>
          ))}
        </div>

        <SectionLabel>Payout Rules</SectionLabel>
        <div style={{ background:"var(--warm-white)", border:"1px solid var(--border)", borderRadius:4, padding:22, marginBottom:24 }}>
          <div style={{ display:"flex", gap:14, flexWrap:"wrap" }}>
            <Field label="Payment Schedule" half>
              <Input value={settings.paymentSchedule} onChange={e=>setSettings(s=>({...s,paymentSchedule:e.target.value}))} />
            </Field>
            <Field label="Minimum Payout ($)" half>
              <Input type="number" value={settings.minimumPayout} onChange={e=>setSettings(s=>({...s,minimumPayout:Number(e.target.value)}))} />
            </Field>
          </div>
          <Field label="Commission Trigger">
            <Input value={settings.commissionTrigger} onChange={e=>setSettings(s=>({...s,commissionTrigger:e.target.value}))} />
          </Field>
          <Field label="Return / Cancellation Policy">
            <Input value={settings.returnPolicy} onChange={e=>setSettings(s=>({...s,returnPolicy:e.target.value}))} />
          </Field>
          <Field label="Tax Form Note">
            <Input value={settings.taxFormNote} onChange={e=>setSettings(s=>({...s,taxFormNote:e.target.value}))} />
          </Field>
          <Field label="Designer Contact Email">
            <Input type="email" value={settings.contactEmail} onChange={e=>setSettings(s=>({...s,contactEmail:e.target.value}))} />
          </Field>
          <Field
            label="Order approval notify email"
            hint="Where to send “pending approval” alerts when designers log sales. Comma-separate multiple addresses. Uses Trigger Email extension on the mail collection; falls back to Designer Contact Email if empty."
          >
            <Input
              type="text"
              value={settings.orderApprovalEmail ?? ""}
              onChange={e=>setSettings(s=>({...s,orderApprovalEmail:e.target.value}))}
              placeholder="orders@showroom.com"
            />
          </Field>
        </div>

        <Btn variant="gold" size="lg" onClick={handleSave}>Save Settings</Btn>
      </div>
    </div>
  );
}
